var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio-group',{attrs:{"size":"small"},model:{value:(_vm.inputType),callback:function ($$v) {_vm.inputType=$$v},expression:"inputType"}},[_c('el-radio-button',{attrs:{"label":"1"}},[_vm._v(" 单行 ")]),_c('el-radio-button',{attrs:{"label":"2"}},[_vm._v(" 数字 ")]),_c('el-radio-button',{attrs:{"label":"4"}},[_vm._v(" 多行 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }